import { __rest, __assign } from 'tslib';
import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-list.css';
import { UitkListOrientations, UitkListSizes, UitkListTypes } from './types.esm.js';
import { UitkListItem } from './uitk-list-item.esm.js';

var getClassNameList = classNames.bind(styles);
var UitkListContext = React.createContext({});
var UitkList = function (props) {
    var bullet = props.bullet, children = props.children, className = props.className, data = props.data, orientation = props.orientation, size = props.size, type = props.type, spacing = props.spacing, indent = props.indent, attributes = __rest(props, ["bullet", "children", "className", "data", "orientation", "size", "type", "spacing", "indent"]);
    var baseClass = 'uitk-typelist'; // Temporary: name clash with menu
    var cssClassNames = getClassNameList(baseClass, orientation && "".concat(baseClass, "-").concat(UitkListOrientations.get(orientation)), size && "".concat(baseClass, "-").concat(UitkListSizes.get(size)), spacing && "".concat(baseClass, "-spacing"), className);
    // Renders the custom Tag
    var Tag = (type && UitkListTypes.get(type)) || 'ul';
    // Renders children if data is used
    var dataGuard = function (dataType) {
        return dataType[0].content !== undefined;
    };
    var newChildren = [];
    data === null || data === void 0 ? void 0 : data.forEach(function (item, index) {
        newChildren.push(React.createElement(UitkListItem, { key: "listitem-".concat(index) }, dataGuard(data) ? [item && (item === null || item === void 0 ? void 0 : item.icon), item === null || item === void 0 ? void 0 : item.content] : item));
    });
    return (React.createElement(Tag, __assign({ className: cssClassNames }, attributes, { role: "list" }),
        React.createElement(UitkListContext.Provider, { value: { bullet: bullet, orientation: orientation, type: type, size: size, indent: indent } }, (!data && children) || newChildren || null)));
};
UitkList.displayName = 'UitkList';
UitkList.defaultProps = {
    bullet: 'default',
    orientation: 'stacked',
    size: 2,
    type: 'unordered',
    spacing: true,
    indent: true
};

export { UitkList, UitkListContext as default };
